import { useContext, useEffect } from "react";
import { Context } from "./EditorContext";
import ContentTab from "./SideContent/Tab";
import { useUpdate } from "ahooks";
import FileManager from "./FileManager/FileManager";

export default () => {
  const { addSubscriber } = useContext(Context);

  const update = useUpdate();

  useEffect(() => {
    // subscribe select node;
    addSubscriber({ type: "NODE_SELECT", fn: update });

    // maybe remove..
  }, [addSubscriber, update]);

  return (
    <>
      <FileManager />
      <ContentTab />
    </>
  );
};
